import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { motion, AnimatePresence } from 'framer-motion';
import App from './App.tsx';
import './i18n';
import './index.css';
import './styles/animations.css';

const LoadingScreen = () => (
  <div className="fixed inset-0 bg-black flex items-center justify-center">
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <div className="w-16 h-16 border-4 border-[#c9ab81] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      <p className="text-[#c9ab81] font-serif">Loading...</p>
    </motion.div>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <AnimatePresence mode="wait">
        <App />
      </AnimatePresence>
    </Suspense>
  </StrictMode>
);